import React, { useState } from "react";
import { Link } from "react-router-dom";
import coinIcon from "../assets/coin_icon.png";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Dropdown,
  DropdownButton,
} from "react-bootstrap";

function AppNavbar() {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  // State for toggling submenu items
  const [submenuOpen, setSubmenuOpen] = useState(false);

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        className="navbar-wrapper"
        rel="noopener noreferrer sponsored"
      >
        <Container>
          {/* Brand */}
          <Navbar.Brand as={Link} to="/" className="m-3">
            <img
              src={coinIcon}
              width="40"
              height="40"
              className="me-2"
              alt="Coin Icon"
              rel="noopener noreferrer sponsored"
            />
            <span className="navbar-logo-text-span">
              Free Credit {new Date().getFullYear()}
            </span>
          </Navbar.Brand>

          {/* Mobile toggle button */}
          <Button className="d-lg-none nav-hamburger-btn" onClick={handleShow}>
            Menu ☰
          </Button>

          {/* Desktop nav links */}
          <Nav className="ms-auto d-none d-lg-flex">
            <Button>Home</Button>
            <div className="vr"></div>
            <Button variant="secondary">Free Credit List</Button>
            <div className="vr"></div>
            <DropdownButton
              id="dropdown-basic-button"
              title="Dropdown button"
              variant="secondary"
            >
              <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
              <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
            </DropdownButton>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar for mobile */}
      <Offcanvas
        show={showSidebar}
        onHide={handleClose}
        placement="start"
        className="nav-offcanvas-container"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav className="flex-column">
            <Nav.Link to="/" onClick={handleClose}>
              Home
            </Nav.Link>
            <Nav.Link to="/" onClick={handleClose}>
              Free Credit List
            </Nav.Link>

            {/* Collapsible Submenu */}
            <Nav.Link
              href="#"
              onClick={() => setSubmenuOpen(!submenuOpen)}
              aria-expanded={submenuOpen}
            >
              Dropdown {submenuOpen ? "▲" : "▼"}
            </Nav.Link>

            {submenuOpen && (
              <Nav className="flex-column ms-3">
                <Nav.Link href="#" onClick={handleClose}>
                  Action
                </Nav.Link>
                <Nav.Link href="#" onClick={handleClose}>
                  Another Action
                </Nav.Link>
              </Nav>
            )}
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AppNavbar;
